import Icons, { IconsProps } from '../Icons';

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.27369 12.5L9.88143 18.6335L9.20111 19.3665L1.26514 12L9.20111 4.63354L9.88143 5.36646L3.27369 11.5H22.0001V12.5H3.27369Z"
        />
      </svg>
    </Icons>
  );
}
